import BackendService from './BackendService';

async function getAllPartiesReport(data) {
  return BackendService.postData(`/reports/all-parties/`, data);
}

const AllPartyReportService = {
  getAllPartiesReport,
};

export default AllPartyReportService;
